import { toast } from 'react-toastify'
import { apiSlice } from '../api/apiSlice'
import {
  FecthTerminalsResponse,
  FetchTerminalQuery,
  IPOSTerminalEditPayload,
  IPOSTerminalPayload,
} from './terminals.types'
import { getErrorMessage } from '../../helpers'
import { ErrorType } from '../shared/shared.type'

export const terminalsApiSlice = apiSlice.injectEndpoints({
  overrideExisting: true,

  endpoints: (builder) => ({
    createTerminal: builder.mutation<
      FecthTerminalsResponse,
      IPOSTerminalPayload
    >({
      query: (args) => ({
        url: `v2/terminals`,
        method: 'POST',
        body: args,
      }),
      invalidatesTags: [{ type: 'TERMINAL', id: 'LIST' }],
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          const res = await queryFulfilled
          if (res.data.success) {
            toast.success('Terminal created successfully.')
          } else {
            toast.error(res.data.message)
          }
        } catch (error) {
          toast.error(getErrorMessage(error as ErrorType))
        }
      },
    }),
    updateTerminal: builder.mutation<
      FecthTerminalsResponse,
      { body: IPOSTerminalEditPayload; id: string }
    >({
      query: (payload) => ({
        url: `v2/terminals/${payload.id}`,
        method: 'PUT',
        body: payload.body,
      }),
      invalidatesTags: (_result, _error, arg) => [
        { type: 'TERMINAL', id: arg.id },
        { type: 'TERMINAL', id: 'LIST' },
      ],
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          const res = await queryFulfilled
          if (res.data.success) {
            toast.success('Terminal updated successfully.')
          } else {
            toast.error(res.data.message)
          }
        } catch (error) {
          toast.error(getErrorMessage(error as ErrorType))
        }
      },
    }),
    activateOrDeactivateTerminal: builder.mutation<
      FecthTerminalsResponse,
      { body: IPOSTerminalEditPayload; id: string; action: string }
    >({
      query: (payload) => ({
        url: `v2/terminals/${payload.id}/${payload.action}`,
        method: 'PATCH',
        body: payload.body,
      }),
      invalidatesTags: (_result, _error, arg) => [
        { type: 'TERMINAL', id: arg.id },
        { type: 'TERMINAL', id: 'LIST' },
      ],
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          const res = await queryFulfilled
          if (res.data.success) {
            toast.success('Terminal updated successfully.')
          } else {
            toast.error(res.data.message)
          }
        } catch (error) {
          toast.error(getErrorMessage(error as ErrorType))
        }
      },
    }),
    getTerminals: builder.query<FecthTerminalsResponse, FetchTerminalQuery>({
      query: (params) => {
        return {
          url: `v2/terminals`,
          method: 'GET',
          params: {
            ...params,
          },
        }
      },
      providesTags: [{ type: 'TERMINAL', id: 'LIST' }],
    }),
  }),
})

export const {
  useGetTerminalsQuery,
  useCreateTerminalMutation,
  useUpdateTerminalMutation,
  useActivateOrDeactivateTerminalMutation,
} = terminalsApiSlice
